import { Helmet } from "react-helmet";

const SITE_NAME = "Spanish with Alex";
const SITE_URL = "https://www.spanishwithalex.com";
const DEFAULT_DESCRIPTION =
  "Learn Spanish with Alex — fun, practical online Spanish lessons with a native teacher from Galicia, Spain.";
const DEFAULT_IMAGE = `${SITE_URL}/logo512.png`;

// Shared per-page <title>/meta so every route stops inheriting the same
// generic tags from public/index.html (duplicate title/description issue).
const Seo = ({ title, description, image, path, type = "website", noIndex = false }) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Learn Spanish Online`;
  const metaDescription = description || DEFAULT_DESCRIPTION;
  const metaImage = image || DEFAULT_IMAGE;
  const url = path
    ? `${SITE_URL}${path}`
    : typeof window !== "undefined"
    ? window.location.href
    : SITE_URL;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      <link rel="canonical" href={url} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={metaImage} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={metaImage} />
    </Helmet>
  );
};

export default Seo;
